module.exports = __webpack_public_path__ + "static/media/Sales-Competency-Inventory-Pie.365578b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sales-competency-inventory/Sales-Competency-Inventory-Pie.svg
// module id = 1349
// module chunks = 0